import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useTutorAuth } from "../context/TutorAuthContext";

/**
 * V25 — Guards a route by:
 *  1. Waiting for `portalEnabled` to resolve (null while checking).
 *  2. If portal OFF → redirect to `/tutor/unavailable`.
 *  3. If portal ON but no tutor logged in → redirect to `/tutor/login`.
 *  4. If logged in → render children.
 */
export default function ProtectedTutorRoute({ children }) {
    const { tutor, portalEnabled } = useTutorAuth();
    const location = useLocation();

    if (portalEnabled === null || tutor === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-50">
                <Loader2 className="w-6 h-6 animate-spin text-slate-400" />
            </div>
        );
    }
    if (!portalEnabled) {
        return <Navigate to="/tutor/unavailable" replace />;
    }
    if (!tutor) {
        return <Navigate to="/tutor/login" replace state={{ from: location.pathname }} />;
    }
    return children;
}
